import React from "react";

/** Krok edycji kończy się zapisem i przejściem do podglądu. */
export default function OrderActions({ dirty, busy, save, preview }) {
  return (
    <div className="card premium-panel premium-actions">
      <h2>Przejdź do podglądu</h2>
      <p className="text-muted">
        Zapisz dane i sprawdź świadectwo w kroku 3. Wystawienie potwierdzisz po
        obejrzeniu podglądu PDF.
      </p>
      {dirty && <p className="small text-muted">Masz niezapisane zmiany.</p>}
      <div className="premium-form-actions">
        <button
          className="btn btn-outline-primary"
          disabled={busy}
          onClick={save}
        >
          Zapisz dane
        </button>
        <button className="btn btn-primary" disabled={busy} onClick={preview}>
          Dalej: podgląd świadectwa
        </button>
      </div>
    </div>
  );
}
